import type { components } from "@/shared/api";

export type Session = components["schemas"]["MeOut"];
export type Role = "admin" | "user";

/** Global role only; item-level decisions use capabilities (entities/item). */
export const isAdmin = (session: Pick<Session, "role"> | null | undefined) =>
  session?.role === "admin";
